import { gql } from '@apollo/client';

export const GET_CHECKGRADE_ANALYSIS_RATE = gql`
  query SkWeb_checkGradeAnalysisRate(
    $classId: ID!
    $titleId: ID!
    $productId: ID!
    $level: String!
  ) {
    checkGradeAnalysisRate(
      classId: $classId
      productId: $productId
      level: $level
      titleId: $titleId
    ) {
      learnRates {
        activityType
        rates {
          id
          title
          rate
        }
      }
      checkRates {
        id
        title
        rate
      }
      finalRate {
        id
        productId
        level
        rate
      }
    }
  }
`;
